module.exports = __webpack_public_path__ + "static/media/races.683c290c.svg";